module.exports = __webpack_public_path__ + "img/03.19f2dab1.jpg";